import { getStableDeviceId } from '../utils/deviceId'

const NORMAL_CLOSE_CODE = 3000;
const HEARTBEAT_TIMEOUT_CLOSE_CODE = 4001;
const RECONNECT_DELAY_MS = 15000;
const HEARTBEAT_INTERVAL_MS = 20000;
const HEARTBEAT_ACK_TIMEOUT_MS = 10000;

let websock = null;
let rec = null;
let isConnect = false;
let connectCallBack = null;
let messageCallBack = null;
let closeCallBack = null;
let activeSocketId = 0;
let lastClosedSocketId = 0;
let lastConnectArgs = {
	wsurl: '',
	accessToken: ''
};

function clearReconnectTimer() {
	if (rec) {
		clearTimeout(rec);
		rec = null;
	}
}

function clearHeartbeatTimers() {
	if (heartCheck.pingTimer) {
		clearTimeout(heartCheck.pingTimer);
		heartCheck.pingTimer = null;
	}
	if (heartCheck.ackTimer) {
		clearTimeout(heartCheck.ackTimer);
		heartCheck.ackTimer = null;
	}
}

function isSocketOpen(socket = websock) {
	return Boolean(socket) && socket.readyState === WebSocket.OPEN;
}

function emitClose(socketId, event) {
	if (socketId <= lastClosedSocketId) {
		return;
	}
	lastClosedSocketId = socketId;
	closeCallBack && closeCallBack(event);
}

function normalizeCloseEvent(event, extra = {}) {
	const rawCode = extra.code != null ? extra.code : event && event.code;
	const parsedCode = Number(rawCode);
	return {
		code: Number.isFinite(parsedCode) ? parsedCode : 0,
		reason: extra.reason || (event && event.reason) || '',
		wasClean: Boolean(event && event.wasClean),
		retryable: extra.retryable !== undefined
			? Boolean(extra.retryable)
			: Number(rawCode) !== NORMAL_CLOSE_CODE
	};
}

function closeSocketSilently(socket, code = NORMAL_CLOSE_CODE) {
	if (!socket) {
		return;
	}
	try {
		if (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING) {
			socket.close(code);
		}
	} catch (error) {
		console.log('关闭WebSocket失败', error);
	}
}

function failCurrentSocket(reason, code = HEARTBEAT_TIMEOUT_CLOSE_CODE) {
	const socket = websock;
	if (!socket) {
		return;
	}
	const socketId = activeSocketId;
	websock = null;
	isConnect = false;
	clearHeartbeatTimers();
	closeSocketSilently(socket, code);
	emitClose(socketId, normalizeCloseEvent(null, {
		code,
		reason,
		retryable: true
	}));
}

const heartCheck = {
	pingTimer: null,
	ackTimer: null,
	schedule() {
		clearHeartbeatTimers();
		if (!isSocketOpen()) {
			return;
		}
		this.pingTimer = setTimeout(() => {
			this.start();
		}, HEARTBEAT_INTERVAL_MS);
	},
	start() {
		if (!isSocketOpen()) {
			return;
		}
		try {
			console.log('发送WebSocket心跳')
			websock.send(JSON.stringify({
				cmd: 1,
				data: {}
			}));
		} catch (error) {
			failCurrentSocket('heartbeat_send_failed');
			return;
		}
		this.ackTimer = setTimeout(() => {
			failCurrentSocket('heartbeat_timeout');
		}, HEARTBEAT_ACK_TIMEOUT_MS);
	},
	ack() {
		if (this.ackTimer) {
			clearTimeout(this.ackTimer);
			this.ackTimer = null;
		}
		this.schedule();
	}
};

let connect = (wsurl, accessToken) => {
	if (isConnect || (websock && (websock.readyState === WebSocket.OPEN || websock.readyState === WebSocket.CONNECTING))) {
		return;
	}
	clearReconnectTimer();
	clearHeartbeatTimers();
	lastConnectArgs = {
		wsurl,
		accessToken
	};
	const socketId = activeSocketId + 1;
	activeSocketId = socketId;
	console.log("连接WebSocket");
	let socket = null;
	try {
		socket = new WebSocket(wsurl);
	} catch (error) {
		websock = null;
		isConnect = false;
		console.log("尝试创建连接失败", error);
		emitClose(socketId, normalizeCloseEvent(null, {
			code: HEARTBEAT_TIMEOUT_CLOSE_CODE,
			reason: 'connect_failed',
			retryable: true
		}));
		return;
	}
	websock = socket;
	socket.onmessage = function (e) {
		if (socketId !== activeSocketId) {
			return;
		}
		let sendInfo = JSON.parse(e.data)
		if (sendInfo.cmd == 0) {
			heartCheck.schedule()
			connectCallBack && connectCallBack();
			console.log('WebSocket登录成功')
		} else if (sendInfo.cmd == 1) {
			heartCheck.ack();
		} else {
			messageCallBack && messageCallBack(sendInfo.cmd, sendInfo.data)
		}
	}
	socket.onclose = function (e) {
		if (socketId !== activeSocketId && socket !== websock) {
			return;
		}
		if (socket === websock) {
			websock = null;
			isConnect = false;
			clearHeartbeatTimers();
		}
		console.log('WebSocket连接关闭')
		emitClose(socketId, normalizeCloseEvent(e));
	}
	socket.onopen = function () {
		if (socketId !== activeSocketId) {
			return;
		}
		console.log("WebSocket连接成功");
		isConnect = true;
		getStableDeviceId().then((deviceId) => {
			if (socketId !== activeSocketId || !isSocketOpen(socket)) {
				return;
			}
			let loginInfo = {
				cmd: 0,
				data: {
					accessToken: accessToken,
					devId: deviceId
				}
			};
			socket.send(JSON.stringify(loginInfo));
		}).catch((error) => {
			console.log('获取稳定设备ID失败', error);
			failCurrentSocket('device_id_unavailable');
		});
	}
	socket.onerror = function (e) {
		if (socketId !== activeSocketId) {
			return;
		}
		console.log('WebSocket连接发生错误:{}', e)
		if (socket.readyState === WebSocket.CLOSING || socket.readyState === WebSocket.CLOSED) {
			emitClose(socketId, normalizeCloseEvent(null, {
				code: HEARTBEAT_TIMEOUT_CLOSE_CODE,
				reason: 'socket_error',
				retryable: true
			}));
			return;
		}
		closeSocketSilently(socket, HEARTBEAT_TIMEOUT_CLOSE_CODE);
	}
};

let reconnect = (wsurl = lastConnectArgs.wsurl, accessToken = lastConnectArgs.accessToken) => {
	console.log("尝试重新连接");
	if (isConnect || !wsurl) {
		return;
	}
	clearReconnectTimer();
	rec = setTimeout(function () {
		connect(wsurl, accessToken);
	}, RECONNECT_DELAY_MS);
};

let close = (code = NORMAL_CLOSE_CODE) => {
	clearReconnectTimer();
	clearHeartbeatTimers();
	const socket = websock;
	websock = null;
	isConnect = false;
	closeSocketSilently(socket, code);
};

let sendMessage = (agentData) => {
	if (isSocketOpen()) {
		websock.send(JSON.stringify(agentData))
	} else if (websock && websock.readyState === WebSocket.CONNECTING) {
		setTimeout(function () {
			sendMessage(agentData)
		}, 1000)
	} else {
		setTimeout(function () {
			sendMessage(agentData)
		}, 1000)
	}
}

let onConnect = (callback) => {
	connectCallBack = callback;
}

let onMessage = (callback) => {
	messageCallBack = callback;
}

let onClose = (callback) => {
	closeCallBack = callback;
}

export {
	connect,
	reconnect,
	close,
	sendMessage,
	onConnect,
	onMessage,
	onClose,
}
